import React from 'react';

const Backlog = () => {
  return <div>Backlog Page</div>;
};

export default Backlog;